import { IUserActivity } from '~/pages/Authenticated/v2/ActivityView/types';

export const parseUserActivitiesToMap = (activities: IUserActivity[]) => {
  const map = new Map();
  activities.forEach((activity) => map.set(activity._id, activity));
  return map;
};
